import { createTheme, ThemeProvider } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { getDesignTokens as getShienDesignTokens } from 'src/themes/ShienTheme';

export const ShienTemplate = () => {
  const designTokens = getShienDesignTokens('light');
  const theme = createTheme(designTokens);
  return (
    <ThemeProvider theme={theme}>
      <Outlet />
    </ThemeProvider>
  );
};
